import { render, staticRenderFns } from "./SolicitacoesServicos.vue?vue&type=template&id=448a01c5"
import script from "./SolicitacoesServicos.vue?vue&type=script&lang=js"
export * from "./SolicitacoesServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports